@if (isInitializing) {
  <fmnts-loading-indicator variant="fontawesome" size="lg" />
}
@if (hasFrame$ | async) {
  <iframe
    #tamaro
    src="/assets/tamaro.html"
    (load)="initTamaroWidget(tamaro)"
    (error)="initializationFailed()"
    [style.display]="!isInitializing && isOnline ? '' : 'none'"
  >
  </iframe>
}

@if (!isOnline && !uploadError) {
  <div class="raisenow-status">
    <fa-icon [icon]="faOfflineMode" size="3x" class="raisenow-status__icon" />
    <p>{{ 'raisenow_offline_status' | translate }}</p>
  </div>
}

@if (uploadError) {
  <div class="raisenow-status">
    <fa-icon [icon]="faUploadError" size="3x" class="raisenow-status__icon" />
    <p>{{ 'raisenow_iframe_error_paragraph' | translate }}</p>
  </div>
}

<fmnts-modal-actions>
  @if (_finalState$ | async) {
    <button type="button" fmnts-button (click)="closeModal()">
      {{ 'ok' | translate }}
    </button>
  } @else {
    @if (useTamaroSubmitButton) {
      <!-- This button is always disabled and only used to display something is in progress. -->
      @if (_paymentInProgress$ | async) {
        <button fmnts-button type="button" disabled>
          <ng-container [ngTemplateOutlet]="paymentInProgress"></ng-container>
        </button>
      }
    }

    <button
      type="button"
      fmnts-button
      [disabled]="_closeDisabled$ | async"
      (click)="closeModal()"
    >
      {{ 'cancel' | translate }}
    </button>
    @if (!useTamaroSubmitButton) {
      <button
        type="button"
        fmnts-button
        color="primary"
        fill="solid"
        [disabled]="(_canStartPayment$ | async) !== true"
        (click)="startPayment()"
      >
        @if (_paymentInProgress$ | async) {
          <fmnts-loading-indicator size="xs"></fmnts-loading-indicator>
          {{ 'raisenow_pay_button_processing' | translate }}
        } @else {
          <fa-icon [icon]="_iconStartPayment"></fa-icon>
          {{ 'raisenow_pay_button' | translate }}
        }
      </button>
    }
  }
</fmnts-modal-actions>

<ng-template #paymentInProgress>
  <fmnts-loading-indicator size="xs" />
  {{ 'raisenow_pay_button_processing' | translate }}
</ng-template>
